import gql from 'graphql-tag'

//--------
// QUERIES
//--------

export const userBaskets = gql`
  query userBaskets($uid: String!){
    userBasketsGraphql1View(contextualFilter: {field_basket_user_reference_target_id: $uid}){
      results{
        fieldIsDabBudget
        fieldIsDTrainingBudget
        fieldBasketCoBranding
        fieldBasketAmount
        fieldBusinessArea{
          entity{
            ...on TaxonomyTermBusinessAreas{
              tid
            }
          }
        }
        fieldBasketUserReference{
          entity{
            ...on User{
              uid
            }
          }
        }
      }
    }
  }
`;

//----------
// MUTATIONS
//----------


// WEBPACK FOOTER //
// ./src/queries/checkout.js